import { Badge } from '@/components/ui/badge'
import { useTranslation } from 'react-i18next'
import { useImageCache } from './image-cache'

export function useIsImageSlotEmpty(imageId: string | null | undefined): boolean {
	const { getImage } = useImageCache()

	return !imageId || !!getImage(imageId).isEmpty
}

export function EmptyImageLabel() {
	const { t } = useTranslation('editor')

	return (
		<Badge className="border-transparent bg-black/60 px-3 py-1 text-white">
			{t('widgets.addImage')}
		</Badge>
	)
}

export function EmptyImageHint() {
	return (
		<div className="pointer-events-none absolute inset-x-0 bottom-3 flex justify-center" data-render-exclude>
			<EmptyImageLabel />
		</div>
	)
}
